<!-- <template>
  <div>
    <div class="row justify-content-space-between" v-if="currentUser.groups.includes('Руководитель')">
      <div class="col-12">
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'labor'}" @click="currentTab = 'labor'">Охрана труда</button>
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'disp'}" @click="currentTab = 'disp'">Диспетчерская</button>
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'fact'}" @click="currentTab = 'fact'">Завод</button>
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'pol'}" @click="currentTab = 'pol'">Полигон</button>
      </div>
    </div>

    <div v-if="currentUser.groups.includes('Руководитель')">
      <HomeLabor v-if="currentTab === 'labor'" />
      <HomeDisp v-if="currentTab === 'disp'" />
      <HomeFactory v-if="currentTab === 'fact'" />
      <HomePoligon v-if="currentTab === 'pol'" />
    </div>

    <div v-else>
      <HomeLabor v-if="currentUser.groups.includes('Охрана труда')" />
      <HomeFactory v-if="currentUser.groups.includes('Завод')" />
      <HomePoligon v-if="currentUser.groups.includes('Полигон') && currentUser.company_inn" />
      <Inn v-if="currentUser.groups.includes('Полигон') && !currentUser.company_inn" />
    </div>

    <ChangePasswordModal
        :show="showChangePasswordModal"
        :user-email="currentUser.email"
        @password-changed="showChangePasswordModal = false"
    />
  </div>
</template>

<script>
import HomeDisp from "@/components/Dashbord/HomeDisp.vue";
import HomeLabor from "@/components/Dashbord/HomeLabor.vue";
import HomeFactory from "@/components/Dashbord/HomeFactory.vue";
import HomePoligon from "@/components/Dashbord/HomePoligon.vue";
import HomeEcolog from "@/components/Dashbord/HomeEcolog.vue";
import Inn from "../views/Polygon/Inn.vue";
import HomeAppeal from "@/components/Dashbord/HomeAppeal.vue";
import ChangePasswordModal from "@/components/ChangePasswordModal.vue";

export default {
  name: 'DashboardView',
  components: {
    HomeDisp,
    HomeLabor,
    HomeFactory,
    HomePoligon,
    HomeEcolog,
    Inn,
    HomeAppeal,
    ChangePasswordModal
  },
  data() {
    return {
      currentTab: 'labor',
      showChangePasswordModal: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    const isOnetime = localStorage.getItem('is_onetime_password') === 'true';
    if (isOnetime) {
      this.showChangePasswordModal = true;
    }
  }
};
</script> -->


<template>
  <div>
    <div class="row justify-content-space-between" v-if="currentUser.groups.includes('Руководитель')">
      <div class="col-12">
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'labor'}" @click="setCurrentTab('labor')">Охрана труда</button>
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'disp'}" @click="setCurrentTab('disp')">Диспетчерская</button>
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'fact'}" @click="setCurrentTab('fact')">Завод</button>
        <button class="btn-tab right-space-16" :class="{'btn-tab-active':currentTab === 'pol'}" @click="setCurrentTab('pol')">Полигон</button>
      </div>
    </div>

    <div v-if="currentUser.groups.includes('Руководитель')">
      <HomeLabor v-if="currentTab === 'labor'" />
      <HomeDisp v-if="currentTab === 'disp'" />
      <HomeFactory v-if="currentTab === 'fact'" />
      <HomePoligon v-if="currentTab === 'pol'" />
    </div>

    <div v-else>
      <HomeLabor v-if="currentUser.groups.includes('Охрана труда')" />
      <HomeFactory v-if="currentUser.groups.includes('Завод')" />
      <HomePoligon v-if="currentUser.groups.includes('Полигон') && currentUser.company_inn" />
      <Inn v-if="currentUser.groups.includes('Полигон') && !currentUser.company_inn" />
    </div>

    <ChangePasswordModal
        :show="showChangePasswordModal"
        :user-email="currentUser.email"
        @password-changed="showChangePasswordModal = false"
    />
  </div>
</template>

<script>
import HomeDisp from "@/components/Dashbord/HomeDisp.vue";
import HomeLabor from "@/components/Dashbord/HomeLabor.vue";
import HomeFactory from "@/components/Dashbord/HomeFactory.vue";
import HomePoligon from "@/components/Dashbord/HomePoligon.vue";
import HomeEcolog from "@/components/Dashbord/HomeEcolog.vue";
import Inn from "../views/Polygon/Inn.vue";
import HomeAppeal from "@/components/Dashbord/HomeAppeal.vue";
import ChangePasswordModal from "@/components/ChangePasswordModal.vue";

export default {
  name: 'DashboardView',
  components: {
    HomeDisp,
    HomeLabor,
    HomeFactory,
    HomePoligon,
    HomeEcolog,
    Inn,
    HomeAppeal,
    ChangePasswordModal
  },
  data() {
    return {
      currentTab: 'labor',
      showChangePasswordModal: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  watch: {
    currentTab(newTab) {
      localStorage.setItem('dashboard_current_tab', newTab);
    }
  },
  methods: {
    setCurrentTab(tab) {
      this.currentTab = tab;
    }
  },
  mounted() {
    const isOnetime = localStorage.getItem('is_onetime_password') === 'true';
    if (isOnetime) {
      this.showChangePasswordModal = true;
    }
    const savedTab = localStorage.getItem('dashboard_current_tab');
    if (savedTab && this.isValidTab(savedTab)) {
      this.currentTab = savedTab;
    }
  },
  beforeDestroy() {
    localStorage.removeItem('dashboard_current_tab');
  },
  methods: {
    setCurrentTab(tab) {
      this.currentTab = tab;
    },
    isValidTab(tab) {
      const validTabs = ['labor', 'disp', 'fact', 'pol'];
      return validTabs.includes(tab);
    }
  }
};
</script>